// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getTechnologyList = createAsyncThunk(
  'technologies/getTechnologyList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/technologies', { params })
    return {
      totalPages: response.data.count.total,
      technologyList: response.data.data,
      loader: false
    }
  }
)

// One page of technologies for paginated dropdowns; doesn't touch the slice
// so the shared technologyList (tables, filters) is left as it is
export const fetchTechnologyOptions = async (params) => {
  const response = await axios.get(baseUrl() + '/technologies', { params })
  return {
    total: response.data?.count?.total,
    technologyList: response.data?.data || []
  }
}

export const getAllTechnologyList = createAsyncThunk(
  'technologies/getAllTechnologyList',
  async (params) => {
    const response = await axios.get(baseUrl() + '/technologies/all', {
      params
    })
    return {
      //totalPages: response.data.count.total,
      // params: response.data.params,
      allTechnologyList: response.data.data
    }
  }
)

// export const getAllDeletedUsers = createAsyncThunk(
//   'getAllDeletedUsers',
//   async (params) => {
//     const response = await axios.get(baseUrl() + '/user/deleted', {
//       params
//     })
//     return {
//       //totalPages: response.data.count.total,
//       params: response.data.params,
//       allDeletedUsers: response.data.data
//     }
//   }
// )

export const getTechnologyById = createAsyncThunk(
  'technologies/getTechnologyById',
  async ({ id }) => {
    const response = await axios.get(baseUrl() + `/technologies/${id}`)
    return {
      data: response.data.data
    }
  }
)
export const getSkillByTechId = createAsyncThunk(
  'technologies/getSkillByTechId',
  async ({ id }) => {
    const response = await axios.get(
      `${baseUrl()}/technologies/skills?technologyIds=${id}`
    )
    return {
      data: response.data
    }
  }
)

export const addTechnology = createAsyncThunk(
  'technologies/addTechnology',
  async (
    { categoryId, skillIds, technologyName, pageNo, pageSize, parameters },
    { dispatch }
  ) => {
    try {
      const res = await axios.post(baseUrl() + '/technologies', {
        categoryId,
        technologyName,
        skillIds
      })
      toast.success(res?.data?.message)
      await dispatch(getTechnologyList({ ...parameters, pageNo, pageSize }))
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const updateTechnology = createAsyncThunk(
  'technologies/updateTechnology',
  async (
    { technologyName, skillIds, categoryId, pageNo, pageSize, id, parameters },
    { dispatch }
  ) => {
    try {
      const res = await axios.put(baseUrl() + '/technologies/' + id, {
        technologyName,
        categoryId,
        skillIds
      })
      toast.success(res?.data?.message)
      await dispatch(getTechnologyList({ pageNo, pageSize, ...parameters }))
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    } finally {
      dispatch(setLoading(false))
    }
  }
)

export const deleteTechnology = createAsyncThunk(
  'technologies/deleteTechnology',
  async ({ id, pageNo, pageSize, search, params }, { dispatch, getState }) => {
    try {
      dispatch(setLoader())
      const res = await axios.delete(baseUrl() + '/technologies/' + id, {
        id
      })
      toast.success(res?.data?.message)
      await dispatch(getTechnologyList({ pageNo, pageSize, search, ...params }))
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const technologies = createSlice({
  name: 'technologies',
  initialState: {
    technologyList: [],
    allTechnologyList: [],
    technologyListById: [],
    skillsListById: [],
    selectedTechnology: null,
    totalPages: 0,
    loader: true,
    loading: false,
    params: {
      pageNo: 1,
      pageSize: 25
    },
    selected: null,
    clearFilter: false,
    filterData: null
  },
  reducers: {
    selectTechnology: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoader: (state) => {
      state.loader = !state.loader
    },
    setParams: (state, action) => {
      state.params = {
        // ...state.params,
        ...action.payload
      }
    },
    setLoading: (state, action) => {
      state.loading = action?.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTechnologyList.fulfilled, (state, action) => {
        ;(state.technologyList = action.payload.technologyList),
          (state.totalPages = action.payload.totalPages)
        state.loader = action.payload.loader
      })
      .addCase(getTechnologyList.pending, (state, action) => {
        state.loader = true
      })
      .addCase(getAllTechnologyList.fulfilled, (state, action) => {
        state.allTechnologyList = action.payload.allTechnologyList
      })
      .addCase(getTechnologyById.fulfilled, (state, action) => {
        state.technologyListById = action.payload.data
      })
      .addCase(getSkillByTechId.fulfilled, (state, action) => {
        state.skillsListById = action.payload.data
      })
  }
})

export const {
  selectTechnology,
  setLoader,
  setParams,
  selectClearFilter,
  setShowDeletedUser,
  setLoading,
  setFilterData
} = technologies.actions

export default technologies.reducer
